import React, { useState, useEffect } from "react";
import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  RadioGroup,
  Radio,
  Text,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import apiHelper from "services/apiHelper";
import CustomToast from "components/CustomToast";
import { useTranslation } from "TranslationContext";

const UnsubscribeEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { translate } = useTranslation();
  const [value, setValue] = useState("");
  const [email, setEmail] = useState("");
  const [isOpened, setIsOpened] = useState(false);
  const [isdisabled, setIsDisabled] = useState(false);
  const toast = useToast();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email"); // get email
    const openParam = params.get("open"); // get open flag

    if (emailParam) setEmail(emailParam);
    if (openParam === "true") setIsOpened(true);
  }, [isOpened, location.search]);

  const payload = { email: email, optin: value, reason: "too much spam" };

  const handleSubmit = async () => {
    setIsDisabled(true);
    if (!email || email.trim() === "") {
      toast({
        position: "top-right",
        status: "error",
        render: () => <CustomToast message={`Email is required`} />,
      });
      return;
    }
    await apiHelper(`api/user/optout`, "post", payload, {}).then((res) => {
      if (res.status === 200) {
        toast({
          position: "top-right",
          status: "error",
          render: () => <CustomToast message={res?.data?.message === "User subscribed successfully" ? translate["UserSubscribedSuccessfully"] : translate["UserUnsubscribedSuccessfully"]} />,
        });
        setIsOpened(false);
        navigate("/");
      } else if (res.status === 401) {
        toast({
          title: "Error",
          description: "Session expired. Please login again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        navigate("/");
      } else {
        toast({
          title: "Error",
          description: res.data.message || translate["somethingwrong"],
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    });
  };

  return (
    <Flex justifyContent="center" alignItems="center" color="white">
      <Modal
        isOpen={isOpened}
        onClose={() => {
          setIsOpened(false);
          navigate("/");
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          bg="#222126"
          borderRadius="20px"
          border="0.5px solid white"
          w="360px"
          color={"#ffffff"}
        >
          <ModalHeader textAlign={"center"}>
            {translate["ConfirmUnsubscriptionEmail"]}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody alignItems={"center"} textAlign={"center"}>
            <Text mb={4}>{translate["UnsubscribeEmail"]}</Text>
            <Flex w="full" justifyContent={"center"}>
              <RadioGroup onChange={setValue} value={value}>
                <Flex w="full" direction="row" gap={6}>
                  <Radio value="0" colorScheme="green">
                    {translate["yes"]}
                  </Radio>
                  <Radio value="1" colorScheme="green">
                    {translate["no"]}
                  </Radio>
                </Flex>
              </RadioGroup>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              isDisabled={isdisabled}
              border={"1px solid white"}
              borderRadius={"20px"}
              w="100%"
              bg="#222126"
              onClick={handleSubmit}
            >
              {isdisabled ? <Spinner size="sm" /> : translate["submit"]}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default UnsubscribeEmail;
